const REGEXP =
  /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i

export const isValidSquuid = (id: string): boolean => {
  return REGEXP.test(id)
}
